// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","662":"29107295","740":"component---src-templates-docs-js"}[chunkId] + "-" + {"351":"3a5d7f6aa3a5ca9b4a46","532":"d1ec7dd336b3231091f6","662":"0d08baa92fee9e7b7829","740":"9043fa523c5aafd9b12f"}[chunkId] + ".js";
};